import moment from "moment";
import config from "../../config";

export const minDate = config.MIN_DATE
  ? moment(config.MIN_DATE)
  : moment("2024-01-01");

export const maxDate = config.MAX_DATE
  ? moment(config.MAX_DATE)
  : moment(new Date());


export const getFirstAndLastDayOfMonth = (date, absoluteRange) => {
  const momentDate = moment(date);

  const firstDayOfMonth = momentDate.clone().startOf("month");
  const lastDayOfMonth = momentDate.clone().endOf("month");

  if (absoluteRange) {
    return {
      from: firstDayOfMonth.toDate(),
      to: lastDayOfMonth.toDate(),
    };
  }

  const earliestAvailableDateForMonth = firstDayOfMonth.isBefore(minDate)
    ? minDate.toDate()
    : firstDayOfMonth.toDate();

  const lastAvailableDateForMonth =
    momentDate.isSame(maxDate, "month") && momentDate.isSame(maxDate, "year")
      ? maxDate.toDate()
      : lastDayOfMonth.toDate();

  return {
    from: earliestAvailableDateForMonth,
    to: lastAvailableDateForMonth,
  };
};

export const getStartTime = (dateObject) => {
  return moment(dateObject).startOf("day").unix();
};

export const getEndTime = (dateObject) => {
  if (moment(dateObject).isSame(maxDate, "day")) {
    return maxDate.unix();
  } else {
    return moment(dateObject).endOf("day").unix();
  }
};

export const isSameDate = (date1, date2) => {
  return moment(date1).isSame(moment(date2), "date");
};
